<template>
  <div class="bigbox">
    <van-form>
      <van-field
        input-align="right"
        v-model="value"
        label="类别名称"
        placeholder="请选择"
      />
    </van-form>
    <div class="mt10">
      <van-button round block type="primary">查询</van-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        value: '茶杯'
      }
    }
  }
</script>

<style scoped>
  .inCon3 p {
    font-size: 1.3rem;
    color: black;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .inCon3 p:last-child {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .inCon3 input {
    display: block;
    width: 10rem;
    height: 5rem;
    font-size: 1.3rem;
    color: #c7c7c7;
    text-align: right
  }

  .inCon3 img {
    width: 1.2rem;
    height: 0.7rem;
  }
</style>
